import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    descriptions: {
      hypertensionDegrees: {
        none: { name: 'Нормальное. Артериальная гипертензия исключена.' },
        0: { name: 'Высокое нормальное. Артериальная гипертензия исключена.' },
        1: { name: 'Артериальная гипертензия 1-ой степени' },
        2: { name: 'Артериальная гипертензия 2-ой степени' },
        3: { name: 'Артериальная гипертензия 3-ей степени' },
        isolate: { name: 'Изолированная систолическая артериальная гипертензия (ИСАГ)', degree: false },
        dadIsolate: { name: 'Изолированная диастолическая артериальная гипертензия (ИДАГ)', degree: false }
      },
      cardiovascularRisk: {
        none: {
          name: 'Риск сердечно-сосудистых осложнений отсутствует',
          key: 'none',
          recomendations: '<a class="recomendation-link" href="#/lifestyle"> Изменение образа жизни</a>'
        },
        noneHigh: {
          name: '',
          key: 'noneHigh',
          recomendations: '<a class="recomendation-link" href="#/lifestyle"> Изменение образа жизни</a>'
        },
        low: {
          name: 'Низкий риск сердечно-сосудистых осложнений',
          key: 'low',
          recomendations: '<a class="recomendation-link" href="#/lifestyle"> Изменение образа жизни</a> в течение нескольких месяцев. При сохранении артериальной гипертензии назначить <a class="recomendation-link" href="#/drug-therapy/low">медикаментозную терапию.</a>'
        },
        middle: {
          name: 'Средний риск сердечно-сосудистых осложнений',
          key: 'middle',
          recomendations: '<a class="recomendation-link" href="#/lifestyle">Изменение образа жизни</a> в течение нескольких недель. При сохранении артериальной гипертензии назначить <a class="recomendation-link" href="#/drug-therapy/middle">медикаментозную терапию.</a>'
        },
        high: {
          name: 'Высокий риск сердечно-сосудистых осложнений',
          key: 'high',
          recomendations: '<a class="recomendation-link" href="#/lifestyle">Изменение образа жизни</a> и <a class="recomendation-link" href="#/drug-therapy/high">медикаментозная терапия.</a>'
        },
        veryHigh: {
          name: 'Очень высокий риск сердечно-сосудистых осложнений',
          key: 'veryHigh',
          recomendations: '<a class="recomendation-link" href="#/lifestyle">Изменение образа жизни</a> и <a class="recomendation-link" href="#/drug-therapy/veryHigh">медикаментозная терапия.</a>'
        }
      },
      hypertonicDiseasse: {},
      recomendations: {
        none: 'Берегите свое здоровье.',
        lifeStyleChange: ''
      }
    },
    results: {
      pressure: {
        sad: '',
        dad: '',
        degree: ''
      },
      hypertensionDegrees: false,
      hypertensionDegreesKey: false,
      riskFactors: [],
      targetOrganDamages: [],
      associatedClinicalConditions: []
    }
  },
  getters: {
    pressure: state => {
      return state.results.pressure
    },
    hypertensionDegree: state => {
      return state.results.hypertensionDegrees
    },
    riskFactors: state => {
      return state.results.riskFactors
    },
    targetOrganDamages: state => {
      return state.results.targetOrganDamages
    },
    clinicalConditions: state => {
      return state.results.associatedClinicalConditions
    }
  },
  mutations: {
    setPressure: (state, pressure) => {
      // state.results.pressure = pressure.sad + '/' + pressure.dad
      state.results.pressure.sad = pressure.sad
      state.results.pressure.dad = pressure.dad
      state.results.pressure.degree = pressure.degree
    },
    setPressureDegree: (state, degree) => {
      let degreeName = degree
      if (typeof degreeName === 'string' && degreeName.indexOf('dadIsolate') !== -1) {
        degreeName = 'dadIsolate'
      } else if (typeof degreeName === 'string' && degreeName.indexOf('isolate') !== -1) {
        degreeName = 'isolate'
      }
      state.results.hypertensionDegrees = state.descriptions.hypertensionDegrees[degreeName].name
      state.results.hypertensionDegreesKey = degree
    },
    setRiskFactors: (state, riskFactors) => {
      state.results.riskFactors = riskFactors
    },
    setTargetOrganDamages: (state, damages) => {
      state.results.targetOrganDamages = damages
    },
    setAssociatedClinicalConditions: (state, conditions) => {
      state.results.associatedClinicalConditions = conditions
    }
  },
  actions: {},
  modules: {}
})
